/**
 * File responsive-table.js.
 * Handles table responsiveness on all pages
 */

function responsiveTable($) {

  function addOuterTableWrapper() {

    // Adds an outer wrapper to each table on a blog page
    $("table").wrap( "<div class='table__outer-wrapper'></div>" );
  }

  function handleEmptyCells() {
    
    $(".responsive-table").each(function() {
      const isTable = $(this).is("table");
      let firstCell, deleteCell, growCell;

      // Determine if true table or mock table, set vars
      if (isTable) {
        firstCell = $(this).find("tr:first-of-type > :first-child");
        deleteCell = firstCell;
        growCell = deleteCell.siblings();
      } else {
        firstCell = $(this).find(".mock-table__content--first .mock-table__content-item:first-of-type span");
        deleteCell = firstCell.parent(".mock-table__content-item");
        growCell = deleteCell.siblings(".mock-table__content-item");
      }

      // If first cell is empty, delete it and grow sibling
      if (firstCell && firstCell.is(":empty")) {
        deleteCell.remove();

        if (isTable) {
          // create new header cell so 'scope' is on the correct element
          $('<th></th>')
            .append(growCell.html())
            .attr("colspan", "2")
            .attr('scope', 'colgroup')
            .addClass("responsive-table__header")
            .prependTo(growCell.parent());
            growCell.remove();
        } else {
          growCell.removeClass("w-50").addClass("w-100 responsive-table__header");

          // move header out of mock-table
          const parentWrapper = $(this).find(".mock-table-wrapper");
          const responsiveHeader = $(this).find(".responsive-table__header").parent();
          responsiveHeader.addClass("mock-table__content--nb");
          responsiveHeader.prependTo(parentWrapper);
        }
      }
    });
  }

  function transposeTable() {

    $("table.responsive-table").each(function() {
      let $this = $(this);
      let transposedRows = [];
      // Loops through each row of each table
      $this.find("tr").each(function(){
        let i = 0;
        // Loops through each cell and appends cells to a new row based on their current column
        $(this).children().each(function(){
          i++;
          if(transposedRows[i] === undefined) {
            transposedRows[i] = $("<tr></tr>");
          }
          const cell = $(this);
          const scope = cell.attr('scope');
          if (scope) {
            cell.attr('scope', scope);
          }
          transposedRows[i].append(cell);
        });
      });
      $this.find("tr").remove();
      
      // Appends the new rows to the table
      $.each(transposedRows, function(index, value) {
        $this.append(value);
      });
    });
  }

  function separateTable() {

    // Loops through each table on the page
    $("table").each(function() {
      let $this = $(this),
      $headers = $this.find('tr:first').clone(),
      $extraRows = $this.find('tr:gt(0)').clone();

      // If there are more than two table columns
      if ($headers[0].children.length > 2) {
        // Creates a new table for each row in the table under the header row. Each new table will be two rows, the first always being the header row.
        for( let i = 0; i < $extraRows.length; i++ ){
          // Clones the main table and then removes all children. This keeps the inline styles.
          let copyStyles = $this.clone().empty();
          // Adds the header row and a single row of content
          copyStyles.append($headers.clone(), $extraRows.slice(i, i+1));
          copyStyles.addClass("hide-desktop responsive-table");
          copyStyles.appendTo($this.parent()); 
        }

        // Hide the desktop table on mobile devices
        $this.addClass("hide-mobile");
      }
    });
  }

  // Creates responsive tables for mobile devices, or checks if responsive tables exist
  if ($('table').length) {
    addOuterTableWrapper();
    separateTable();
    transposeTable();
    handleEmptyCells();
  } else if ($('.responsive-table').length) {
    handleEmptyCells();
  }

}

// Handle expandable tables if max number of mobile tables set
const tableExpandTrigger = document.querySelectorAll('.mock-table__expand-trigger');

function toggleGroup(group) {
  group.classList.toggle('mock-table__expand-group--active');
}

function toggleTrigger(trigger) {
  const text = trigger.querySelector('.mock-table__expand-trigger-text');
  const expandText = 'View more';
  const collapseText = 'View less';
  trigger.classList.toggle('mock-table__expand-trigger--active');
  text.textContent == expandText ? text.textContent = collapseText : text.textContent = expandText;
}

tableExpandTrigger.forEach(trigger => {
  trigger.addEventListener('click', e => {
    const group = e.target.parentElement.querySelector('.mock-table__expand-group');

    console.log(group);
    
    toggleGroup(group);
    toggleTrigger(e.target);
  })
})
